import { createBulkMutationHook, createDefaultMutationHook } from "hooks/useMutationHandler";

import { FLOWS_PROJECT_ROLE_BINDING_DELETE } from "./gql";

export const useBulkFlowsProjectRoleBindingDelete = createBulkMutationHook(
  FLOWS_PROJECT_ROLE_BINDING_DELETE
);

const useFlowsProjectRoleBindingDelete = createDefaultMutationHook(
  FLOWS_PROJECT_ROLE_BINDING_DELETE
);

export default useFlowsProjectRoleBindingDelete;
